/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totalbusinesses1Inputs */

const en_totalbusinesses1 = /** @type {(inputs: Totalbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Businesses`)
};

const de_totalbusinesses1 = /** @type {(inputs: Totalbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen gesamt`)
};

/**
* | output |
* | --- |
* | "Total Businesses" |
*
* @param {Totalbusinesses1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const totalbusinesses1 = /** @type {((inputs?: Totalbusinesses1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totalbusinesses1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_totalbusinesses1(inputs)
	return de_totalbusinesses1(inputs)
});
export { totalbusinesses1 as "totalBusinesses" }